import httpClient from "./httpClient";

const base = "/shift-teacher-assign";

export function listShiftTeacherAssigns() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function assignShiftTeacher(staffIds, shiftId) {
  const params = new URLSearchParams();
  staffIds.forEach((id) => params.append("staffIds", id));
  params.append("shiftId", shiftId);
  return httpClient.post(`${base}?${params.toString()}`).then((res) => res.data);
}

export function deleteShiftTeacherAssign(assignId) {
  return httpClient.delete(`${base}/${assignId}`).then((res) => res.data);
}
